<script setup>
import { init } from '@weathernews/btos-javascript-modules/src/wniutil/init.js'

onMounted(() => {
  init()
  initDatadog()
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
